module.exports = __webpack_public_path__ + "img/bulb.0319eccd.svg";